import React from 'react'
import HelpWrapper from './Help.style'
import callIcon from '../../assets/images/icons/call.svg'
import emailIcon from '../../assets/images/icons/email.svg'
import chatIcon from "../../assets/images/chat-icon.svg";
import whatsappIcon from '../../assets/images/icons/whats-app.svg'
import report from '../../assets/images/icons/report.svg'
import { useTranslation } from 'react-i18next'
import AppLinks from "../../config.json";

const HelpYou = React.forwardRef(({ visibleHelp }, ref) => {
    const { i18n } = useTranslation();

    const showRTL = i18n.dir() === 'rtl'

    const handleWhatsappClick = () => {
        window.open(AppLinks.WHATSAPP_LINK);
    };

    const handlePhoneNumberClick = () => {
        window.open("tel:800 124 9990");
    };
    const handleEmailClick = () => {
        window.location = 'mailto:Care@tawuniya.com.sa'
    };
    const handleReportClick = () => {
        window.location.href = 'https://tawuniya.com/individuals/customerservice/support';
    };

    return (
        <HelpWrapper ref={ref} >
            <div className={`dropdown-menu ${visibleHelp && " show"} ${showRTL ? " left" : ""}`}>
                <div className="help-heading">{i18n.t("HELPYOU.HEADING")}</div>
                <p className="team-support grey-border-bottom">{i18n.t("HELPYOU.CONTACT")}</p>
                <div className="d-flex c-pointer" onClick={handlePhoneNumberClick}>
                    <div><img src={callIcon} alt="Chat Icon" /></div>
                    <div className={showRTL ? "me-15" : "ms-15"}>
                        <div className="chat-with">{i18n.t("HELPYOU.CALLCENTER")}</div>
                        <div className="live-chat">{i18n.t("HELPYOU.CALLCENTERNUMBER")}</div>
                    </div>
                </div>
                <div className="d-flex pt-20 c-pointer" onClick={handleReportClick}>
                    <div><img src={report} alt="Chat Icon" /></div>
                    <div className={showRTL ? "me-15" : "ms-15"}>
                        <div className="chat-with">{i18n.t("HELPYOU.OPENTICKET")}</div>
                        <div className="live-chat">{i18n.t("HELPYOU.SUBMIT")}</div>
                        <div className="chat-with">{i18n.t("HELPYOU.ANYTIME")}</div>
                    </div>
                </div>
                <div className="d-flex pt-20 c-pointer" onClick={handleWhatsappClick}>
                    <div>
                        <img src={whatsappIcon} alt="Chat Icon" />
                    </div>
                    <div className={showRTL ? "me-15" : "ms-15"}>
                        <div className="chat-with">{i18n.t("HELPYOU.WHATSAPP")}</div>
                        <div className="live-chat">{i18n.t("HELPYOU.WHATSAPPNUMBER")}</div>
                        <div className="chat-with">{i18n.t("HELPYOU.CHATNUMBER")}</div>
                    </div>
                </div>
                <div className="d-flex pt-20 pb-20 grey-border-bottom c-pointer" onClick={handleWhatsappClick}>
                    <div>
                        <img src={chatIcon} alt="Chat Icon" />
                    </div>
                    <div className={showRTL ? "me-15" : "ms-15"}>
                        <div className="chat-with">{i18n.t("HELPYOU.EXECUTIVES")}</div>
                        <div className="live-chat">{i18n.t("HELPYOU.STARTCHAT")}</div>
                    </div>
                </div>
                <div className="d-flex pt-20 c-pointer" onClick={handleEmailClick}>
                    <div><img src={emailIcon} alt="Chat Icon" /></div>
                    <div className={showRTL ? "me-15" : "ms-15"}>
                        <div className="chat-with">{i18n.t("HELPYOU.EMAIL")}</div>
                        <div className="live-chat">{i18n.t("HELPYOU.EMAILID")}</div>
                    </div>
                </div>
            </div>
        </HelpWrapper>
    )
})

export default HelpYou
